import { Breadcrumbs, Link } from "@mezo-org/mezo-clay"
import {
  createFileRoute,
  Link as LinkReactRouter,
  Outlet,
  useParams,
} from "@tanstack/react-router"

import { ENABLE_VAULTS_ON_MEZO, routes, vault } from "#/shared/constants"
import { useVaultsRoute } from "#/shared/hooks"
import { VaultAddress } from "#/shared/types"
import { getCurrencySymbol } from "#/shared/utils"

type ExploreBreadcrumbsProps = {
  route: string
  paramKey: string
  mainPageLabel: string
  subpageLabel: (param: string) => string
}

type ExploreSubPage = "vaults"

const navItems: Record<ExploreSubPage, ExploreBreadcrumbsProps> = {
  vaults: {
    route: routes.EXPLORE_VAULTS,
    mainPageLabel: "Vaults",
    paramKey: "poolAddress",
    subpageLabel: (address: string) =>
      `August ${getCurrencySymbol(
        vault.VAULT_ADDRESS_TO_DEPOSIT_TOKEN[address as VaultAddress],
      )}`,
  },
} as const

function ExploreBreadcrumbs({
  route,
  mainPageLabel,
  subpageLabel,
  paramKey,
}: ExploreBreadcrumbsProps) {
  const params = useParams({ strict: false })
  const param = params[paramKey]

  return (
    <Breadcrumbs
      overrides={{
        Root: {
          style: ({ $theme }) => ({
            margin: `${$theme.sizing.scale900} 0`,
          }),
        },
      }}
    >
      <Link $as={LinkReactRouter} to={routes.EXPLORE}>
        Explore
      </Link>

      {param ? (
        <Link $as={LinkReactRouter} to={route}>
          {mainPageLabel}
        </Link>
      ) : (
        <span>{mainPageLabel}</span>
      )}

      {param && <span>{subpageLabel(param)}</span>}
    </Breadcrumbs>
  )
}

function ExploreHeader() {
  const isVaultsRoute = useVaultsRoute()

  if (!ENABLE_VAULTS_ON_MEZO) return null

  if (isVaultsRoute) return <ExploreBreadcrumbs {...navItems.vaults} />

  return null
}

function RouteComponent() {
  return (
    <>
      <ExploreHeader />
      <Outlet />
    </>
  )
}

export const Route = createFileRoute("/explore/_layout")({
  component: RouteComponent,
})
